import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';
import styles from './annotationsSidebar.scss';
import annotationService from '../../services/AnnotationService';

const AnnotationsVisibilityButtonContent = ({ isListEmpty, annotationsVisibility }) => {
    const title = annotationsVisibility ? t('header.hideAllAnnotations') : t('header.showAllAnnotations');
    const fontIcon = annotationsVisibility ? 'fa-eye' : 'fa-eye-slash';

    const toggleVisibility = () => {
        annotationService.setVisibility(!annotationsVisibility);
    };

    return isListEmpty ? null : (<button
        className={styles.annotationsHeaderButton}
        id="annotationsVisibilityButton"
        aria-label={t('annotations.visibilityButton.ariaLabelText')}
        title={title}
        onClick={toggleVisibility}
    >
        <span className="sr-only">{title}</span>
        <i className={`fa ${fontIcon} fa-3`} aria-hidden="true" />
    </button>);
};

AnnotationsVisibilityButtonContent.propTypes = {
    isListEmpty: PropTypes.bool.isRequired,
    annotationsVisibility: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    const { studentHighlights: { annotationList, annotationsVisibility } } = state;

    return {
        isListEmpty: annotationList.length === 0,
        annotationsVisibility,
    };
}

const AnnotationsVisibilityButton = connect(mapStateToProps)(AnnotationsVisibilityButtonContent);

export default AnnotationsVisibilityButton;
